import { AuroraBackground } from './AuroraBackground';
import { useParallax } from '../../hooks/useParallax';
import './Hero.css';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Hero plein cadre réutilisé sur l'Accueil et les pages Particuliers/Professionnels :
 * photo en fond (avec parallax léger) + voile dégradé + formes aurora + contenu en cascade.
 * Sans image renseignée, retombe sur un dégradé de couleur de marque (tone).
 */
export function Hero({ eyebrow, title, subtitle, imageUrl, tone = 'neutral', children }) {
  const parallaxRef = useParallax(0.12);
  const auroraTone = imageUrl ? 'dark' : tone === 'primary' ? 'warm' : 'dark';

  return (
    <section className={`hero-full hero-full--${tone}`}>
      {imageUrl && (
        <div className="hero-full__bg" ref={parallaxRef}>
          <img src={`${API_URL}${imageUrl}`} alt="" />
        </div>
      )}
      {imageUrl && <div className="hero-full__overlay" />}
      <AuroraBackground tone={auroraTone} />

      <div className="container hero-full__content">
        {eyebrow && <p className="hero-full__eyebrow hero-reveal hero-reveal--1">{eyebrow}</p>}
        <h1 className="hero-full__title hero-reveal hero-reveal--2">{title}</h1>
        {subtitle && <p className="hero-full__subtitle hero-reveal hero-reveal--3">{subtitle}</p>}
        {children && <div className="hero-reveal hero-reveal--4">{children}</div>}
      </div>
    </section>
  );
}
